import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

// Understated text + arrow link (internal route or external href).
export const ArrowLink = ({ to, href, children, testId, className = "", light = false }) => {
  const content = (
    <>
      <span className="link-underline">{children}</span>
      <ArrowRight size={15} strokeWidth={1.5} />
    </>
  );
  const cls = `arrow-link ${light ? "arrow-link--light" : ""} ${className}`;
  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={cls}
        data-testid={testId}
        style={light ? { color: "#F7F4EE" } : undefined}
      >
        {content}
      </a>
    );
  }
  return (
    <Link to={to} className={cls} data-testid={testId} style={light ? { color: "#F7F4EE" } : undefined}>
      {content}
    </Link>
  );
};

export default ArrowLink;
